import React from 'react';
import type { TReportSection } from '@@config/report';
import SectionRenderer from '@@components/SectionRenderer/SectionRenderer';

type TReportSectionsProps = {
    sections: Record<string, TReportSection>;
};

const ReportSections: React.FC<TReportSectionsProps> = ({ sections }) => {
    // Sort sections by SECTION_INDEX
    const sortedSections = Object.entries(sections).sort(([, a], [, b]) => a.SECTION_INDEX - b.SECTION_INDEX);

    return (
        <>
            {sortedSections.map(([sectionKey, section]) => (
                <SectionRenderer key={sectionKey} section={section} />
            ))}
        </>
    );
};

export type { TReportSectionsProps };
export default ReportSections;
